/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosEnumSectionSizes, AssetSectionFragment } from "@cosmos/hygraph-schema";

import {
	BackgroundContainer,
	Caption,
	CosmosAsset,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
} from "@components/elements";
import { Box, VStack } from "@panda/jsx";
import { css, cx } from "@panda/css";
import { smStyles, mdStyles, lgStyles } from "@components/styles/size.style";

export const AssetSection = ({
	config,
	size,
	sectionAsset,
	caption,
}: AssetSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(sectionAsset?.url);
	if (!validHeading && !validContent) return null;
	const effectiveSize = size ?? CosmosEnumSectionSizes.Md;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack alignItems="stretch" gap="eds.dimension.56" className="asset-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<Box w="full">
								<Box
									className={cx(
										effectiveSize === CosmosEnumSectionSizes.Sm ? smStyles : null,
										effectiveSize === CosmosEnumSectionSizes.Md ? mdStyles : null,
										effectiveSize === CosmosEnumSectionSizes.Lg ? lgStyles : null,
									)}
									marginInline={config?.heading?.centeredVerticalStack ? "auto" : "unset"}
								>
									<Caption caption={caption}>
										<CosmosAsset
											className={css({
												position: "relative",
												overflow: "hidden",
												aspectRatio: "16/9",
												borderRadius: "eds.borderRadius.24",
												w: "full",
												h: "full",
											})}
											asset={sectionAsset}
										/>
									</Caption>
								</Box>
							</Box>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
